import React, { useState, useEffect } from "react";
import { FaCog, FaChevronDown } from "react-icons/fa";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Header from "../../../header/header.js";
import Navvbar from "../../../header/Navvbar.js";
import axios from "axios";

// Shipping Parameters Form
const Shipping = ({
  startDate,
  endDate,
  shipper,
  type,
  format,
  setStartDate,
  setEndDate,
  setShipper,
  setType,
  setFormat,
  onRun,
  isLoading,
}) => {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: "500px",
        padding: "10px",
        marginLeft: "-1px",
        marginTop: "-20px",
        backgroundColor: "#f4f4f4",
        borderTop: "3px solid #004aad",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <h2 style={{ color: "#004aad", fontSize: "20px", marginTop: "0", marginBottom: "20px" }}>
        ⚙️ Parameters
      </h2>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
        <label htmlFor="startDate" style={{ fontWeight: "bold", color: "#555" }}>
          Start Date *
        </label>
        <input
          id="startDate"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={{ flexGrow: 1, maxWidth: "200px", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
        <label htmlFor="endDate" style={{ fontWeight: "bold", color: "#555" }}>
          End Date *
        </label>
        <input
          id="endDate"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={{ flexGrow: 1, maxWidth: "200px", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
        <label htmlFor="shipper" style={{ fontWeight: "bold", color: "#555" }}>
          Shipper *
        </label>
        <select
          id="shipper"
          value={shipper}
          onChange={(e) => setShipper(e.target.value)}
          style={{
            flexGrow: 1,
            maxWidth: "200px",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            marginLeft: "10px",
          }}
        >
          <option>All</option>
          <option>Royal Mail</option>
          <option>Shipper 1</option>
          <option>Shipper 2</option>
        </select>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
        <label htmlFor="type" style={{ fontWeight: "bold", color: "#555" }}>
          Type *
        </label>
        <select
          id="type"
          value={type}
          onChange={(e) => setType(e.target.value)}
          style={{
            flexGrow: 1,
            maxWidth: "200px",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            marginLeft: "10px",
          }}
        >
          <option>Pickups and Deliveries</option>
          <option>Pickups Only</option>
          <option>Deliveries Only</option>
        </select>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
        <label htmlFor="format" style={{ fontWeight: "bold", color: "#555" }}>
          Format *
        </label>
        <select
          id="format"
          value={format}
          onChange={(e) => setFormat(e.target.value)}
          style={{
            flexGrow: 1,
            maxWidth: "200px",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            marginLeft: "10px",
          }}
        >
          <option>On Screen</option>
          <option>PDF</option>
          <option>Excel</option>
        </select>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", gap: "10px" }}>
        <button
          onClick={() => {
            setStartDate("");
            setEndDate("");
            setShipper("All");
            setType("Pickups and Deliveries");
            setFormat("On Screen");
            onRun(true);
          }}
          style={{
            backgroundColor: "#ccc",
            color: "#333",
            border: "1px solid #ccc",
            padding: "8px 16px",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Clear
        </button>
        <button
          onClick={() => onRun(false)}
          disabled={isLoading}
          style={{
            backgroundColor: isLoading ? "#ccc" : "#004aad",
            color: isLoading ? "#666" : "#fff",
            border: isLoading ? "1px solid #ccc" : "1px solid #004aad",
            padding: "8px 16px",
            borderRadius: "4px",
            cursor: isLoading ? "not-allowed" : "pointer",
            fontWeight: "bold",
          }}
        >
          {isLoading ? "Loading..." : "Run"}
        </button>
      </div>
    </div>
  );
};

// Updated Delivery Status Modal Component
const DeliveryStatusModal = ({ isOpen, onClose, caseNumber, patientName, filters, onDeliveryUpdate }) => {
  if (!isOpen) return null;

  const handleSetDelivered = async () => {
    try {
      const response = await axios.put(`https://hms.backend.hiragroupcloud.com/api/cases/${caseNumber}/delivery-status`, {
        delivered: true
      });


      onDeliveryUpdate(caseNumber, response.data.case.delivered_date);
      onClose();
    } catch (error) {
      console.error("Error updating delivery status:", error);
      alert("Failed to update delivery status");
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ backgroundColor: "#004aad" }}>
          <h3>Case Delivery Details</h3>
          <button className="modal-close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f0f0f0" }}>
                <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #ddd" }}>
                  Case #
                </th>
                <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #ddd" }}>
                  Patient
                </th>
                <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #ddd" }}>
                  Delivery Status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #ddd", color: "#004aad" }}>
                  <Link
                    to={`/case/${caseNumber}`}
                    state={{ filters }}
                    style={{
                      textDecoration: "none",
                      color: "#004aad",
                      fontSize: "17px",
                    }}
                  >
                    #{caseNumber}
                  </Link>
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #ddd", color: "#004aad" }}>
                  {patientName}
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                  <button
                    onClick={handleSetDelivered}
                    style={{
                      padding: "8px 16px",
                      borderRadius: "4px",
                      border: "1px solid #004aad",
                      backgroundColor: "#004aad",
                      color: "#fff",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Set deliver
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="modal-footer">
          <button
            className="modal-button cancel"
            onClick={onClose}
            style={{
              backgroundColor: "#ccc",
              color: "#333",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const Addshipping = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showActionsMenu, setShowActionsMenu] = useState({});
  const [showChangeShipperModal, setShowChangeShipperModal] = useState(false);
  const [selectedShipper, setSelectedShipper] = useState("Royal Mail");
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);
  const [data, setData] = useState([]);
  const [rawDeliveryCases, setRawDeliveryCases] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const today = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(location.state?.dateRange?.startDate || today);
  const [endDate, setEndDate] = useState(location.state?.dateRange?.endDate || today);
  const [shipper, setShipper] = useState(location.state?.shipper || "All");
  const [type, setType] = useState(location.state?.type || "Pickups and Deliveries");
  const [format, setFormat] = useState("On Screen");
  const [showParameters, setShowParameters] = useState(false);

  const fetchData = async (useFormParams = false) => {
    setIsLoading(true);
    setError(null);

    try {
      

      let effectiveStartDate = startDate;
      let effectiveEndDate = endDate;
      let effectiveShipper = shipper;
      let effectiveType = type;

      if (!useFormParams) {
        const { selectedPeriod, dateRange, todayDeliveryCases, type: stateType, shipper: stateShipper } = location.state || {};
        

        if (todayDeliveryCases && todayDeliveryCases.length > 0) {
          let deliveryCases = todayDeliveryCases;

          const accountsResponse = await axios.get("https://hms.backend.hiragroupcloud.com/api/account/account");
          const allAccounts = accountsResponse.data?.data || [];
          

          deliveryCases = deliveryCases.map((caseItem) => {
            const account = allAccounts.find(
              (acc) =>
                acc.accountId === caseItem.accountId ||
                acc._id === caseItem.accountId ||
                acc.accountId === caseItem.account_holder ||
                acc._id === caseItem.account_holder ||
                acc.account_name === caseItem.account_holder ||
                acc.account_name === caseItem.account_name
            );
            return {
              ...caseItem,
              account_holder: caseItem.account_name || (account ? account.account_name : "Unknown Account"),
              address: account
                ? `${account.address}${account.address2 ? ", " + account.address2 : ""}, ${account.city || ""}, ${account.state || ""}, ${account.country || ""}${account.zip ? ", " + account.zip : ""}`
                : caseItem.address || "No Address Provided",
              contact: account
                ? account.telephone || account.contact || "No Contact Provided"
                : caseItem.contact || "No Contact Provided",
              email: account ? account.email : "",
              accountId: account ? account.accountId : caseItem.accountId || "",
              accountData: account || null,
              case_number: caseItem.case_id || caseItem.caseNumber,
            };
          });

          setRawDeliveryCases(deliveryCases);
          setIsLoading(false);
          return;
        }

        if (dateRange) {
          effectiveStartDate = dateRange.startDate;
          effectiveEndDate = dateRange.endDate;
          setStartDate(dateRange.startDate);
          setEndDate(dateRange.endDate);
        }
        if (stateShipper) {
          effectiveShipper = stateShipper;
          setShipper(stateShipper);
        }
        if (stateType) {
          effectiveType = stateType;
          setType(stateType);
        }
      }

      if (!effectiveStartDate || !effectiveEndDate) {
        throw new Error("Start date and end date are required.");
      }
      if (new Date(effectiveEndDate) < new Date(effectiveStartDate)) {
        throw new Error("End date cannot be before start date.");
      }

      const params = {
        startDate: effectiveStartDate,
        endDate: effectiveEndDate,
      };


      const response = await axios.get("https://hms.backend.hiragroupcloud.com/api/cases/cases", { params });

      let allCases = Array.isArray(response.data) ? response.data : [];

      const accountsResponse = await axios.get("https://hms.backend.hiragroupcloud.com/api/account/account");
      const allAccounts = accountsResponse.data?.data || [];


      let deliveryCases = allCases
        .filter((c) => c.delivery_date)
        .filter((c) => {
          const deliveryDate = new Date(c.delivery_date);
          const start = new Date(effectiveStartDate);
          const end = new Date(effectiveEndDate);
          return deliveryDate >= start && deliveryDate <= end;
        })
        .filter((c) => {
          if (!useFormParams || effectiveShipper === "All") return true;
          return (c.shipper || "Royal Mail") === effectiveShipper;
        })
        .filter((c) => {
          if (!useFormParams || effectiveType === "Pickups and Deliveries") return true;
          if (effectiveType === "Pickups Only") return c.pickup_status;
          if (effectiveType === "Deliveries Only") return c.delivery_status;
          return true;
        })
        .map((caseItem) => {
          const account = allAccounts.find(
            (acc) =>
              acc.accountId === caseItem.accountId ||
              acc._id === caseItem.accountId ||
              acc.accountId === caseItem.account_holder ||
              acc._id === caseItem.account_holder ||
              acc.account_name === caseItem.account_holder ||
              acc.account_name === caseItem.account_name
          );
          return {
            ...caseItem,
            account_holder: caseItem.account_name || (account ? account.account_name : "Unknown Account"),
            address: account
              ? `${account.address}${account.address2 ? ", " + account.address2 : ""}, ${account.city || ""}, ${account.state || ""}, ${account.country || ""}${account.zip ? ", " + account.zip : ""}`
              : caseItem.address || "No Address Provided",
            contact: account
              ? account.telephone || account.contact || "No Contact Provided"
              : caseItem.contact || "No Contact Provided",
            email: account ? account.email : "",
            accountId: account ? account.accountId : caseItem.accountId || "",
            accountData: account || null,
            case_number: caseItem.case_id || caseItem.caseNumber,
          };
        });


      setRawDeliveryCases(deliveryCases);

      if (deliveryCases.length === 0) {
        setError("No delivery cases found for the selected parameters.");
      }
    } catch (err) {
      console.error("Error fetching data:", err.message);
      if (err.response) {
        console.error("API response error:", err.response.data);
      }
      setError(err.message || "Failed to load delivery cases. Please check the console for details.");
      setRawDeliveryCases([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {

    fetchData(false);
  }, [location.state]);

  const handleRun = (isClear = false) => {
    if (isClear) {
      setRawDeliveryCases([]);
      setData([]);
      setError(null);
      return;
    }

    if (!startDate || !endDate) {
      setError("Please select both start and end dates.");
      return;
    }
    if (new Date(endDate) < new Date(startDate)) {
      setError("End date cannot be before start date.");
      return;
    }

    fetchData(true);
  };

  // Add this function to handle delivery status update
  const handleDeliveryUpdate = (caseNumber, deliveredDate) => {
    setData(prevData =>
      prevData.map(item =>
        item.caseNumber === caseNumber
          ? {
              ...item,
              deliver: deliveredDate
                ? new Date(deliveredDate).toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })
                : "0/1",
              isDelivered: true
            }
          : item
      )
    );
  };

  useEffect(() => {
    const formattedData = rawDeliveryCases.map((caseItem, index) => ({
      id: index + 1,
      name: caseItem.account_holder || "Unknown Account",
      address: caseItem.address || "No Address Provided",
      contact: caseItem.contact || "No Contact Provided",
      email: caseItem.email || "",
      date: caseItem.delivery_date
        ? new Date(caseItem.delivery_date).toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric",
          }) + " - Any Time"
        : "No Date",
      shipper: caseItem.shipper || "Royal Mail",
      notes: "",
      // Check if case is already delivered
      deliver: caseItem.delivery_status && caseItem.delivered_date
        ? new Date(caseItem.delivered_date).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })
        : "0/1",
      pickupPackages: "0",
      pickupStatus: "0",
      caseNumber: caseItem.case_number || caseItem.case_id || caseItem.caseNumber || "Unknown",
      patientName: `${caseItem.first_name || ""} ${caseItem.last_name || ""}`.trim() || "Unknown",
      accountId: caseItem.accountId || "",
      accountData: caseItem.accountData || null,
      isDelivered: caseItem.delivery_status || false // Add this flag
    }));


    setData(formattedData);

    if (format === "PDF" && formattedData.length > 0) {
      
    } else if (format === "Excel" && formattedData.length > 0) {
      
    }
  }, [rawDeliveryCases, format]);

  const containerStyle = {
    fontFamily: "Arial, sans-serif",
    padding: "0px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const tableWrapperStyle = { maxWidth: "1700px", padding: "20px" };
  const headerRowStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    paddingBottom: "10px",
  };
  const headerTitleStyle = { fontSize: "1.5rem", fontWeight: "normal", color: "#333", margin: "0" };
  const paramsButtonStyle = {
    color: "#fff",
    border: "1px solid #004aad",
    backgroundColor: "#004aad",
    padding: "8px 15px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontSize: "0.9rem",
    fontWeight: "bold",
    transition: "all 0.3s ease",
  };

  const tableHeaderStyle = {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 2fr",
    fontWeight: "bold",
    backgroundColor: "#f4f4f4",
    padding: "10px",
    color: "#000",
    borderBottom: "2px solid #ddd",
  };
  const tableBodyStyle = { padding: "0 10px" };
  const tableRowStyle = {
    display: "grid",
    gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 2fr",
    padding: "15px 0",
    borderBottom: "1px solid #eee",
    alignItems: "center",
  };

  const cellStyle = {
    padding: "15px",
    wordWrap: "break-word",
  };
  const accountCellStyle = { ...cellStyle };
  const accountNameStyle = { fontWeight: "bold", color: "#004aad", fontSize: "1.0em", margin: "0 0 5px 0" };
  const contactInfoStyle = { fontSize: "0.9em", color: "#555", margin: "0", lineHeight: "1.4" };
  // const actionsCellStyle = { ...cellStyle, textAlign: "right" };
  // const actionsButtonStyle = {
  //   backgroundColor: "#004aad",
  //   color: "#fff",
  //   border: "1px solid #004aad",
  //   padding: "8px 15px",
  //   borderRadius: "4px",
  //   cursor: "pointer",
  //   display: "inline-flex",
  //   alignItems: "center",
  //   gap: "5px",
  //   fontSize: "0.9rem",
  //   fontWeight: "bold",
  //   transition: "all 0.3s ease",
  // };



  const handleDeliveryStatusClick = (caseNumber, patientName) => {
    const filters = { startDate, endDate, shipper, type };
    
    setSelectedCase({ caseNumber, patientName, filters });
    setShowDeliveryModal(true);
  };

  // Update the Delivery Status cell rendering function
  const renderDeliveryCell = (item) => {
    if (item.isDelivered) {
      // If delivered, show the date and time
      return (
        <div style={{ ...cellStyle, color: "black", fontWeight: "bold" }}>
          {item.deliver}
        </div>
      );
    } else {
      // If not delivered, show clickable button
      return (
        <div
          className="delivery-status-cell"
          style={{ ...cellStyle, cursor: "pointer" }}
          onClick={() => handleDeliveryStatusClick(item.caseNumber, item.patientName)}
        >
          <button
            style={{
              padding: "8px 16px",
              borderRadius: "4px",
              border: "1px solid #004aad",
              backgroundColor: "#004aad",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Set Deliver
          </button>
        </div>
      );
    }
  };

  const renderChangeShipperModal = () => {
    if (!showChangeShipperModal) return null;
    return (
      <div className="modal-overlay" onClick={() => setShowChangeShipperModal(false)}>
        <div className="modal-container" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header" style={{ backgroundColor: "#004aad" }}>
            <h3>Change Shipper</h3>
            <button
              className="modal-close-button"
              onClick={() => setShowChangeShipperModal(false)}
            >
              &times;
            </button>
          </div>
          <div className="modal-body">
            <label htmlFor="shipper-select">Shipper</label>
            <select
              id="shipper-select"
              value={selectedShipper}
              onChange={(e) => setSelectedShipper(e.target.value)}
            >
              <option value="Royal Mail">Royal Mail</option>
              <option value="DHL">DHL</option>
              <option value="FedEx">FedEx</option>
            </select>
          </div>
          <div className="modal-footer">
            <button
              className="modal-button cancel"
              onClick={() => setShowChangeShipperModal(false)}
            >
              Cancel
            </button>
            <button
              className="modal-button ok"
              onClick={() => {
                
                setShowChangeShipperModal(false);
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        .modal-container {
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.2);
          width: 600px;
          max-width: 90%;
          overflow: hidden;
        }
        .modal-header {
          padding: 15px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #fff;
        }
        .modal-close-button {
          background: none;
          border: none;
          color: #fff;
          font-size: 1.5rem;
          cursor: pointer;
        }
        .modal-body {
          padding: 20px;
        }
        .modal-body label {
          display: block;
          font-weight: bold;
          margin-bottom: 5px;
          color: #333;
        }
        .modal-body select {
          width: 100%;
          padding: 8px;
          border: 1px solid #ccc;
          borderRadius: 4px;
          font-size: 1rem;
        }
        .modal-footer {
          padding: 15px 20px;
          text-align: right;
          border-top: 1px solid #eee;
        }
        .modal-button {
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-weight: bold;
          font-size: 0.9rem;
          margin-left: 10px;
        }
        .modal-button.cancel {
          background: #ccc;
          border: 1px solid #ccc;
          color: #555;
        }
        .modal-button.ok {
          background: #004aad;
          border: 1px solid #004aad;
          color: #fff;
        }
        .actions-dropdown-menu {
          position: absolute;
          right: 0;
          top: 100%;
          background: #fff;
          border: 1px solid #ccc;
          borderRadius: 4px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          margin-top: 5px;
          min-width: 150px;
          z-index: 500;
        }
        .actions-dropdown-menu button {
          display: block;
          width: 100%;
          text-align: left;
          padding: 10px 15px;
          background: none;
          border: none;
          cursor: pointer;
          font-size: 0.9rem;
          color: #004aad;
          fontWeight: bold;
          transition: all 0.3s ease;
        }
        .actions-dropdown-menu button:hover {
          background-color: #f0f0f0;
        }
        .delivery-status-cell {
          cursor: pointer;
          color: #004aad;
        }
        .params-button:hover,
        .actions-button:hover {
          background-color: #003882;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        }
      `}</style>

      <Header />
      <Navvbar />
      <div style={containerStyle}>
        <div style={tableWrapperStyle}>
          <div style={headerRowStyle}>
            <h2 style={headerTitleStyle}>
              Shipping {startDate || "N/A"} to {endDate || "N/A"}
            </h2>
            <button
              className="params-button"
              style={paramsButtonStyle}
              onClick={() => setShowParameters(!showParameters)}
            >
              ⚙️ Parameters
            </button>
          </div>

          {showParameters && (
            <Shipping
              startDate={startDate}
              endDate={endDate}
              shipper={shipper}
              type={type}
              format={format}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setShipper={setShipper}
              setType={setType}
              setFormat={setFormat}
              onRun={handleRun}
              isLoading={isLoading}
            />
          )}

          {isLoading ? (
            <div style={{ padding: "20px", textAlign: "center" }}>Loading...</div>
          ) : error ? (
            <div style={{ padding: "20px", textAlign: "center", color: "red" }}>{error}</div>
          ) : (
            <>
              <div style={tableHeaderStyle}>
                <div style={cellStyle}>Account</div>
                <div style={cellStyle}>Date</div>
                <div style={cellStyle}>Shipper</div>
                <div style={cellStyle}>Case ID</div>
                <div style={cellStyle}>Patient Name</div>
                <div style={cellStyle}>Pickup Notes</div>
                <div style={cellStyle}>Deliver</div>
                <div style={cellStyle}>Pickup Packages</div>
                <div style={cellStyle}>Pickup Status</div>
              </div>

              <div style={tableBodyStyle}>
                {data.length > 0 ? (
                  data.map((item) => (
                    <div key={item.id} style={tableRowStyle}>
                      <div style={accountCellStyle}>
                        <h3 style={accountNameStyle}>
                          {item.accountId && item.accountData ? (
                            <Link
                              to={`/TabsWorking/${item.accountId}`}
                              state={{
                                accountName: item.name,
                                accountData: item.accountData,
                              }}
                              style={{
                                textDecoration: "none",
                                color: "#004aad",
                                fontSize: "16px",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.name}
                            </Link>
                          ) : (
                            <span>{item.name}</span>
                          )}
                        </h3>
                        <p style={contactInfoStyle}>
                          <span>{item.address}</span>
                          <br />
                          {item.contact}
                          {item.email && (
                            <>
                              <br />
                              {item.email}
                            </>
                          )}
                        </p>
                      </div>
                      <div style={cellStyle}>{item.date}</div>
                      <div style={cellStyle}>{item.shipper}</div>
                      <div style={cellStyle}>{item.caseNumber}</div>
                      <div style={cellStyle}>{item.patientName}</div>
                      <div style={cellStyle}>{item.notes}</div>

                      {/* Updated Delivery Status Cell */}
                      {renderDeliveryCell(item)}

                      <div style={cellStyle}>{item.pickupPackages}</div>
                      <div style={{ ...cellStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>{item.pickupStatus}</span>
                          {/* <button
                            className="actions-button"
                            style={actionsButtonStyle}
                            onClick={() => handleActionsClick(item.id)}
                          >
                            test
                          </button> */}

                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    No delivery cases found for the selected parameters.
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {renderChangeShipperModal()}

      <DeliveryStatusModal
        isOpen={showDeliveryModal}
        onClose={() => setShowDeliveryModal(false)}
        caseNumber={selectedCase?.caseNumber}
        patientName={selectedCase?.patientName}
        filters={selectedCase?.filters}
        onDeliveryUpdate={handleDeliveryUpdate}
      />
    </>
  );
};

export default Addshipping;